import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const PRICE_LIST_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required("Molimo Vas da unesite naziv"),
  vehicleGroupId: yup.string().required("Molimo Vas da odaberete grupu vozila"),
});
